import { useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { trackPageView } from "../utils/analytics";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const SKIP_PAGE_VIEW_PATHS = [
  "/stripe/success",
  "/checkout-success",
];

export default function PageViewTracker() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const path = location.pathname + location.search;
    if (SKIP_PAGE_VIEW_PATHS.includes(location.pathname)) {
      return;
    }
    const userPayload = user
      ? { email: user.email, phone: user.phone, userId: user._id || user.id }
      : undefined;

    (async () => {
      const event_id = await trackPageView({ user: userPayload, path });
      axios
        .post(
          `${API_URL}/analytics/page-view`,
          { event_id, path },
          { withCredentials: true },
        )
        .catch(() => {});
    })();
  }, [location.pathname, location.search, user]);

  return null;
}
